<template>
  <div class="vch-retailers" v-if="!retailers">
    <slot></slot>
  </div>
  <div class="vch-retailers" v-else>
    <ul class="vch-slider__list" v-if="sliderDisplay">
      <li
        class="vch-slider__item"
        v-for="retailer of retailers"
        :key="retailer.Id"
      >
        <a
          class="retailer__wrapper"
          :href="retailer.Link"
          target="_blank"
          @click="clickTracking(retailer.Tagging.click)"
        >
          <div class="retailer__logo">
            <img :src="retailer.Logo" :alt="retailer.Title" />
          </div>
          <span class="retailer__price" v-if="retailer.Price">
            <span class="price-lg"
              >{{ retailer.PriceFront
              }}<span class="price-sm"
                >{{ retailer.PriceEnd }} {{ retailer.CurrencySymbol }}</span
              >
            </span>
          </span>
          <span
            class="retailer__website"
            :class="[retailer.Price ? '' : '--no-price']"
          >
            <span>{{ retailer.Title }}</span>
            <svg width="24" height="24" role="img">
              <use href="/assets/sprite/icons.svg#arrow-black" />
            </svg>
          </span>
        </a>
      </li>
    </ul>
    <ul class="channel-advisor-items" v-else>
      <li class="mb-lg" v-for="retailer of retailers" :key="retailer.Id">
        <h2 class="channel-advisor__logo">
          <img :src="retailer.Logo" :alt="retailer.Title" />
        </h2>
        <span class="channel-advisor__price" v-if="retailer.Price"
          ><span class="price-lg"
            >{{ retailer.PriceFront }}.<span class="price-sm"
              >{{ retailer.PriceEnd }} {{ retailer.CurrencySymbol }}</span
            ></span
          >
        </span>
        <a
          class="button -primary"
          :href="retailer.Link"
          target="_blank"
          @click="clickTracking(retailer.Tagging.click)"
          >{{ buyOnlineText }}</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName } from 'Directives/variant-selector/variant-selector';
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'vch-retailers-item-list',
  props: {
    apiEndpoint: {
      type: String,
      required: true,
    },
    sliderDisplay: {
      type: Boolean,
      required: false,
      default: true,
    },
    buyOnlineText: {
      type: String,
      required: false,
      default: 'Buy Online',
    },
    productId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      retailers: null,
      currentVariantEAN: null,
    };
  },
  mounted() {
    eventBus.$on(`${busName}::selected`, this.updateVariantEAN);
    // Check channel advisor for potential new variant ID
    const channelAdvisor = document.getElementById('channelAdvisor');
    if (channelAdvisor && channelAdvisor.dataset.variantid) {
      this.updateVariantEAN(channelAdvisor.dataset.variantid);
    }
  },
  beforeDestroy() {
    eventBus.$off(`${busName}::selected`, this.updateVariantEAN);
  },
  methods: {
    updateVariantEAN(variantEAN) {
      if (variantEAN !== this.currentVariantEAN) {
        this.currentVariantEAN = variantEAN;
        this.updateERetailers();
      }
    },
    updateERetailers() {
      fetch(
        `${this.apiEndpoint}?ean=${this.currentVariantEAN}&productId=${this.productId}`
      )
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }
          if (data && data.length) {
            this.retailers = data;
            this.eRetailerUnavailable(this.retailers);
            this.parsePricing();
          } else {
            this.retailers = null;
            this.eRetailerUnavailable(this.retailers);
          }
        })
        .catch((error) => {
          this.retailers = null;
          //this.eRetailerUnavailable(this.retailers);
          console.error(error);
        });
    },
    parsePricing() {
      this.retailers = this.retailers.map((r) => {
        if (!r.Price) return r;
        const priceAsString = r.Price.toString();
        let priceFront, priceEnd;
        if (priceAsString.indexOf('.') > 0) {
          [priceFront, priceEnd] = priceAsString.split('.');
          priceEnd = `.${priceEnd}`;
        } else {
          priceFront = priceAsString;
          priceEnd = null;
        }
        return {
          ...r,
          PriceFront: priceFront,
          PriceEnd: priceEnd,
        };
      });
    },
    eRetailerUnavailable(data) {
      const select = (selector) => document.querySelector(selector);
      const buyBtn = select('.vch-pdp-grid__content .button.-primary.buy-btn');
      const retailerInfo = select(
        '.vch-pdp-grid__content .eretailer-unavailable'
      );
      if(!retailerInfo) return;
      const channelAdvisorWrapper = select('.channel-advisor');
      if (data && data.length) {
        retailerInfo?.classList.add('hideInfo');
        buyBtn?.classList.remove('hideBtn');
        !buyBtn
          ? channelAdvisorWrapper?.classList.remove('mb-md')
          : channelAdvisorWrapper?.classList.add('mb-md');
      } else {
        retailerInfo?.classList.remove('hideInfo');
        buyBtn?.classList.add('hideBtn');
        !retailerInfo
          ? channelAdvisorWrapper?.classList.remove('mb-md')
          : channelAdvisorWrapper?.classList.add('mb-md');
      }
    },
    clickTracking(trackingData) {
      pushEvent(trackingData);
    },
  },
};
</script>
